// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".included-services[data-v-fe3c8018]{padding:4rem 0}", "",{"version":3,"sources":["webpack://./resources/js/components/order-status/vehicle-services.vue"],"names":[],"mappings":"AACA,oCACE,cAAF","sourcesContent":["\n.included-services {\n  padding: 4rem 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
